// extracted by mini-css-extract-plugin
export default {"price":"vba-z","onSale":"wba-z","msrpLabelPrice":"xba-z","msrpLabel":"yba-z","originalPrice":"zba-z"};